import { useSelector } from 'react-redux';
import { LoadingScreen } from '../app-active-loading/LoadingScreen';
import { isExperimentActive } from '../store/experiments/selectors';
import { getActiveLoading } from '../store/loading-status/selectors';
import { getIsMobile } from '../utils/deviceUtils';
import { Step } from '../views/Step';
import { enabledExperimentsForFeedback } from './feedbackUtils';
import { useCurrentStep } from './useCurrentStep';

const checkExperiments = state => {
  return enabledExperimentsForFeedback().some(key => isExperimentActive(state, key));
};

export const useFeedbackWidget = () => {
  const {
    currentStep
  } = useCurrentStep();
  const activeLoading = useSelector(getActiveLoading);
  const isLoading = activeLoading && LoadingScreen[activeLoading];
  const allowedSteps = [Step.CrmExperienceLevel, Step.UseCase, Step.HubInterest];
  const shouldShowFeedbackWidget = useSelector(checkExperiments);
  const isMobile = getIsMobile();
  return shouldShowFeedbackWidget && allowedSteps.includes(currentStep) && !isLoading && !isMobile;
};